export const unknown = (value: never): never => {
    throw new Error('Unknown state!');
}